// extracted by mini-css-extract-plugin
export default {"title":"Dashboard_title__pgmoF"};